import { render, staticRenderFns } from "./mobileBottom.vue?vue&type=template&id=c3a950ca&scoped=true"
import script from "./mobileBottom.vue?vue&type=script&lang=js"
export * from "./mobileBottom.vue?vue&type=script&lang=js"
import style0 from "./mobileBottom.vue?vue&type=style&index=0&id=c3a950ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a950ca",
  null
  
)

export default component.exports